const CustomEvents = {
  cartItemAdded: 'flu:cart:item-added',
  cartUpdated: 'flu:cart:updated',
  cartError: 'flu:cart:error',
  productVariantChange: 'flu:product:variant-change',
  productQuanityUpdate: 'flu:product:quantity-update',
  quickCartOpen: 'flu:quick-cart:open',
  quickCartClose: 'flu:quick-cart:close',
};

const dispatchCustomEvent = (eventName, data = {}) => {
  const detail = { detail: data };
  const event = new CustomEvent(eventName, data ? detail : null);

  document.dispatchEvent(event);
};

export { CustomEvents, dispatchCustomEvent };
